import styled from 'styled-components'
import { CircularProgress } from '@material-ui/core'
import { Card as YogaCard, Button } from '@gympass/yoga'

import getBreakpoint from '@client/utils/breakpoints'
import tokens from '@gympass/yoga-tokens'

import { H4, H5, H6, Body1 } from '@components/Text'

export const Card = styled(YogaCard)`
  padding: 24px;
  margin-top: 48px;
  border-radius: 16px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    padding: 40px;
  }
`

export const CardHeader = styled(YogaCard.Header)`
  margin-bottom: 32px;
`

export const CardContent = styled(YogaCard.Content)`
  margin-bottom: 32px;
`

export const CardActions = styled(YogaCard.Actions)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-bottom: 0;
  }
`

export const CardTitle = styled(H4)`
  font-style: normal;
  font-weight: 900;
  line-height: 23px;
  font-family: Rubik;
`

export const DividerWrapper = styled.section`
  margin-bottom: 32px;
`

export const ContentRow = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  &:last-of-type {
    margin-bottom: 0px;
  }
`

export const PriceDescription = styled(H6)`
  font-weight: ${({ bold }) => (bold ? '700' : 'normal')};
  line-height: 19px;
  color: var(--secondary-text);
  font-family: Rubik;
`

export const PriceValue = styled(H5)`
  font-weight: 700;
  line-height: 21px;
  color: #001027;
  font-family: Rubik;
`

export const TotalWrapper = styled(H6)`
  font-weight: normal;
  font-family: Rubik;
  em {
    font-style: normal;
    font-size: 18px;
    text-decoration: none;
  }
  span {
    margin-left: 2px;
    font-size: 24px;
    font-weight: 700;
  }
`

export const LinkButton = styled(Button.Link)`
  margin: 0;
`

export const LinkButtonText = styled(Body1)`
  font-weight: 700;
  line-height: 17px;
  text-decoration-line: underline;
  color: #d8385e;
  font-family: Rubik;
`

export const CouponWrapper = styled.section`
  display: flex;
  flex-direction: column;
  border-radius: 100px;
  width: 100%;
`

export const Form = styled.section`
  display: flex;
  border-radius: 100px;
  border: 1px solid #dce0ed;
  padding: 8px;
  margin-top: 24px;
`

export const Input = styled.input`
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  padding: 0 24px;
  border: none;
  width: 100%;
  outline: 0;
  border-radius: 100px;
`

export const CouponRow = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`

export const ErrorMessage = styled(Body1)`
  flex: 1;
  font-size: 16px;
  color: #f46152;
  font-family: Rubik;
  @media (min-width: ${tokens.breakpoints.md.width}px) {
    font-size: 12px;
    line-height: 16px;
  }
`

export const CancelCoupon = styled(Button.Link)`
  display: flex;
  align-items: center;
  color: #d8385e;
  margin: 0 0 0 auto;
  text-decoration: underline;
  font-weight: 600;
  &:not([disabled]):hover {
    color: #d8385e;
  }
  font-family: Rubik;
`

export const Progress = styled(CircularProgress)`
  &.MuiCircularProgress-colorPrimary {
    color: #ffffff;
  }
`

export const ButtonText = styled(H6)`
  font-weight: 700;
  font-family: Rubik;
`

export const DiscountButton = styled(Button)`
  background: #001027;
  border: 1px solid #001027;
  &:hover {
    border-shadow: 0 4px 8px rgb(0, 0, 0, 0.45);
  }

  &:focus {
    opacity: 0.75;
    border-shadow: 0 4px 8px rgb(0, 0, 0, 0.45);
  }

  &:active {
    opacity: 0.75;
    background: #231b22;
  }
`

export const DependentsValue = styled.s`
  padding-right: 5px;
  color: var(--secondary-text);
  font-family: Rubik;
`
